<template>
    <div
      class="checkbox"
    >
        <input
            :id="id"
            type="checkbox"
            :checked="checked"
            :class="{'disabled' : disabled}"
            :disabled="disabled"
            tabindex="-1"
            @click="onClick()"
        >
        <label
          :for="id"
          tabindex="0"
        >
        </label>
    </div>
</template>

<script setup>
  import {defineProps, defineEmits} from "vue";

  const emit = defineEmits([
    'selectAll'
  ])

  const props = defineProps({
    disabled : {
      default : false,
    },

    checked : {
      default: false,
    },

    id : {
      default: 'selectAll'
    }
  })

  const onClick = () => {
    emit('selectAll');
  }
</script>